import * as clockReportActions from '../constants/clockReportActions';
import { WorkLogsState } from '../../interfaces/redux.interface';
import httpService from '../../services/http.service';
import moment from 'moment';

const setDate = (payload: WorkLogsState) => {
	return {
		type: clockReportActions.SET_DATE,
		payload,
	};
};

export const setTodayWorkLogsAction = (payload: WorkLogsState) => {
	return {
		type: clockReportActions.SET_TODAY_WORKLOGS,
		payload,
	};
};

export const toggleReFetch = () => {
	return {
		type: clockReportActions.TOGGLE_REFETCH_FLAG,
	};
};

const setOpenDateModal = (payload: WorkLogsState) => {
	return {
		type: clockReportActions.SET_OPEN_CHOSEN_DATE_MODAL,
		payload,
	};
};

export const setChosenDate = (date: string) => dispatch =>
	dispatch(setDate({ chosenDate: date }));

// A work log started before midnight keeps running after it, but the server
// files it under the day it started, so today's list doesn't return it as active
const getYesterdayActiveWorkLog = async (today: moment.Moment) => {
	try {
		const res = await httpService.api<any>({
			type: 'getWorkLogListForClock',
			params: {
				date: today.clone().subtract(1, 'day').format('YYYY-MM-DD'),
			},
		});
		if (!res?.activeWorkLog) return null;
		return {
			activeWorkLog: res.activeWorkLog,
			activeWorkLogDayTotalReported: res.data.reduce(
				(total: number, worklog: any) => total + worklog.total / 60,
				0,
			),
		};
	} catch (err) {
		return null;
	}
};

export const setTodayWorklogs = (todayWorkLogs?: any) => async dispatch => {
	try {
		const today = moment().local();
		const res =
			todayWorkLogs ||
			(await httpService.api<any>({
				type: 'getWorkLogListForClock',
				params: {
					date: today.format('YYYY-MM-DD'),
				},
			}));
		if (res) {
			const yesterdayActive = res.activeWorkLog
				? null
				: await getYesterdayActiveWorkLog(today);
			await dispatch(
				setTodayWorkLogsAction({ ...res, ...yesterdayActive }),
			);
		}
	} catch (err) {
		console.log(err);
	}
};

export const setOpenChosenDateModal = (isOpen: boolean) => dispatch =>
	dispatch(setOpenDateModal({ openChosenDateModal: isOpen }));

//export const toggleReFetch = () => dispatch => dispatch(toggleReFetchFlag())
